import { html, LitElement, css, unsafeCSS } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

import '../parts/card';
import '../parts/event';
import '../components/comments';

import style from './monster.scss';
import { DATA_AREAS, DATA_MONSTERS } from '../data/sources';
import { friendlyURL, getNameFromURL, setTitle, trackPage } from '../shared/utils';

export class MonsterPage extends LitElement {

    static get properties() {
        return {
            name: String,
            stats: Object
        }
    }

    constructor() {
        super();
        this.name = null;   
        this.stats = null;  
    }

    static styles = css`
        ${unsafeCSS(style)}        
    `;

    connectedCallback() {
        super.connectedCallback();   
        trackPage();    
        this.name = getNameFromURL();
        setTitle(this.name);
        this.fetchData();
    }

    async fetchData() {                        
        if(!this.name){
            return;
        }
        let statsjson = await fetch(`./api/monsterstats/${this.name}`);
        this.stats = await statsjson.json();                        
    }

    render() {    
        const cls = DATA_MONSTERS.filter(c=>c.name===this.name)[0];
        const areas = DATA_AREAS.filter(a=>a.areaEnemies.indexOf(this.name)!==-1 || a.boss === this.name || a.miniBosses.indexOf(this.name) !== -1);        
        return html`            
            <h1>
                <img loading="lazy" class="header-image" src='./images/monsters/${cls.artwork||'creature_icon_bolgar'}.webp' alt=${cls.name} /> ${cls.name}
            </h1>            
            <p>${unsafeHTML(cls.desc)}</p>
            <div class="bubble big">Health: ${cls.hp} <img loading="lazy" class="cost-small" src='./images/health.webp' alt="Health" /></div>
            <div class="bubble big">Energy per Turn: ${cls.energy}</div>
            <div class="bubble big">Cards per Turn: ${cls.cards}</div>       
            ${this.stats ? html`
            ${this.stats.bosses[0]?.count ? html`<div class="bubble big">Deaths: ${this.stats.bosses[0]?.count}</div>`:''}
            <div class="bubble big">Players Slain: ${this.stats.slainby[0]?.count||0}</div>       
            `:''}     
            ${areas.length > 0 ? html`
                <h3>Cantos</h3>
                ${areas.map(a=>html`
                    <div class="row">
                        <img loading="lazy" class="world" src="./images/card_world_${+a.name.substr(0,2)}.webp" alt=${a.areaName} /> <a href='./area/${friendlyURL(a.name)}'>${a.areaName.replace('<br>',' ')}</a>
                    </div>
                `)}
            `:''}
            <h3>Decklist (${cls.decklist.length})</h3>
            ${cls.decklist.map(wep=>html`
                <div class="row">
                    <card-part id=${wep}></card-part>
                </div>
            `)}
            <h3>Enchantments (${cls.enchants.length})</h3>
            ${cls.enchants.map(wep=>html`
                <div class="row">
                    <card-part id=${wep}></card-part>
                </div>
            `)}
            ${cls.closingevent ? html`
                <h3>Post Combat Event</h3>
                <event-part id=${cls.closingevent}></event-part>
            `:''}
            ${cls.related?.events.length > 0 ?html`
                <h3>Related Events (${cls.related.events.length})</h3>
                ${cls.related.events.map(c=>html`
                    <div class="row">
                        <event-part id=${c}></event-part>
                    </div>
                `)}
            `:''}
            <comments-component path=${window.location.pathname}></comments-component>
        `;
    }
}

customElements.define('monster-page', MonsterPage);